// Performance optimization module

export class PerformanceManager {
  constructor() {
    this.init();
  }

  private init(): void {
    document.addEventListener("DOMContentLoaded", () => {
      this.preloadCriticalResources();
    });
  }

  private preloadCriticalResources(): void {
    // Preload founder images
    const imageUrls = [
      "assets/images/paul-goulet-headshot.jpg",
      "assets/images/lloyd-bustard-headshot.jpg",
    ];

    imageUrls.forEach((url) => {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = url;
      document.head.appendChild(link);
    });
  }

  // Method to preload additional resources
  public preloadResource(
    url: string,
    type: "image" | "script" | "style" | "font" = "image"
  ): void {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = type;
    link.href = url;
    document.head.appendChild(link);
  }

  // Method to preload multiple resources
  public preloadResources(
    resources: Array<{
      url: string;
      type?: "image" | "script" | "style" | "font";
    }>
  ): void {
    resources.forEach(({ url, type = "image" }) => {
      this.preloadResource(url, type);
    });
  }
}
